import { Field } from 'common/fields/entities/field'

export function replaceFieldsInString(str: string, fields: Field[]): string {
  const regexp = /{{([^\n{}]{1,})}}/g

  if (!str) {
    return ''
  }

  return str.replace(regexp, (_, fieldId) => {
    const field = fields.find((field) => field.id === fieldId)
    return `{{${field?.caption || fieldId}}}`
  })
}
